// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "/1.jpeg",
    title: "RkWeatherShow",
    description:
      "this is the weather site provide fast and best weather details recently.",
    tech_stack: ["React Native", "html", "NextJs", "Java Script"],
    github_url: "https://github.com/Ramjha890/Rkwheathershow-main",
    demo_url: "https://rkmohanweather.netlify.app/",
  },
  {
    img: "/2.jpeg",
    title: "Todo main",
    description:
      "for add task and your works",
    tech_stack: ["React", "html", "Node.js"],
    github_url: "https://github.com/Ramjha890/todo-main",
    demo_url: "https://thunderous-sprinkles-d8d9ad.netlify.app/",
  },
  {
    img: "/3.jpeg",
    title: "AI Chat-Bot",
    description:
      "AI Chat-Bot for any field you are use it. this is very best. AI Assistance",
    tech_stack: ["Python", "Streamlit"],
    github_url: "https://github.com/Ramjha890/AI-chat-Bot",
    demo_url: "https://ai-chat-bot2-2.onrender.com/",
  },
  {
    img: "/4.jpeg",
    title: "Square to Circle Converter",
    description:
      "square image convert to circle image. it's image tool",
    tech_stack: ["HTML"],
    github_url: "https://github.com/Ramjha890/Square-to-circle-Converter",
    demo_url: "https://rkjhasquaretocircleconveter.netlify.app/",
  },
  {
    img: "/5.jpeg",
    title: "AI Tools Website",
    description:
      "the collection of the AI tools for free here.",
    tech_stack: ["HTML"],
    github_url: "https://github.com/Ramjha890/AI-Tools-Website",
    demo_url: "https://aitoolsbyrkmohan.netlify.app/",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "/6.webp",
    name: "HTML",
  },
  {
    img: "/8.png",
    name: "CSS",
  },
  {
    img: "/9.webp",
    name: "JavaScript",
  },
  {
    img: "/10.png",
    name: "ReactJS",
  },
  {
    img: "/11.webp",
    name: "NextJs",
  },
  {
    img: "/12.webp",
    name: "Typescript",
  },
  {
    img: "/13.webp",
    name: "Git",
  },
  {
    img: "/14.png",
    name: "React Native",
  },
  {
    img: "/15.webp",
    name: "NodeJS",
  },
  {
    img: "/16.png",
    name: "Firebase",
  },
  {
    img: "/17.webp",
    name: "MongoDB",
  },
  {
    img: "/18.png",
    name: "Python",
  },
  {
    img: "/19.png",
    name: "Flask",
  },
  {
    img: "/20.webp",
    name: "C",
  },
  {
    img: "/22.png",
    name: "Java",
  },
  {
    img: "/23.png",
    name: "MySQL",
  },
  {
    img: "/24.png",
    name: "Bootstrap",
  },
  {
    img: "/25.png",
    name: "Material UI",
  },
  {
    img: "/26.png",
    name: "Figma",
  },
  {
    img: "/27.webp",
    name: "TailwindCSS",
  },
  {
    img: "/28.png",
    name: "VS Code",
  },
];
